import * as firebase from 'firebase';

// Get a Firestore instance
// eslint-disable-next-line import/prefer-default-export
export const db = firebase
  .initializeApp({
    apiKey: 'AIzaSyBSOFsNdqo-KCzcLUd2z7tZ_lWkJOz1mYc',
    authDomain: 'app-development-1554297605090.firebaseapp.com',
    databaseURL: 'https://app-development-1554297605090.firebaseio.com',
    projectId: 'app-development-1554297605090',
    storageBucket: 'app-development-1554297605090.appspot.com',
    messagingSenderId: '481607595708',
    appId: '1:481607595708:web:7b41622724fe174d',
  }).firestore();

// export { TimeStamp, GeoPoint } = firebase.firestore;
